import { render } from "./SitupsGame.vue?vue&type=template&id=40a02de4&scoped=true"
import script from "./SitupsGame.vue?vue&type=script&lang=js"
export * from "./SitupsGame.vue?vue&type=script&lang=js"

import "./SitupsGame.vue?vue&type=style&index=0&id=40a02de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a02de4"]])

export default __exports__